import { render, staticRenderFns } from "./PageBuongusto.vue?vue&type=template&id=67e59311"
import script from "./PageBuongusto.vue?vue&type=script&lang=js"
export * from "./PageBuongusto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports